/**
 * Delay the execution of the next line of code by the given milliseconds
 * @param ms Milliseconds to delay
 * @returns Returns promise that resolves after the given milliseconds
 */
export function delay(ms: number): Promise<void> {
    return new Promise<void>((res) => {
        setTimeout(() => {
            res();
        }, ms);
    });
}
